import performance from "./assets/images/data-2-performance.png";
import solutions from "./assets/images/data-2-solutions.png";
import storytelling from "./assets/images/data-storytelling.png";
import innovation from "./assets/images/innovation.png";
import refereeTechnologies from "./assets/images/referee-technologies.png";

export enum IlluSection {
  storytelling = "data-storytelling",
  innovation = "innovation",
  refereeTechnologies = "referee-technologies",
  solutions = "data-2-solutions",
  performance = "data-2-performance"
}

export const ILLU_SECTION_IMAGES = {
  [IlluSection.performance]: {
    image: performance,
    width: "auto",
    height: "80vh",
    title: "Data 2 Performance"
  },
  [IlluSection.solutions]: {
    image: solutions,
    width: "60vw",
    height: "auto",
    title: "Data 2 Solutions"
  },
  [IlluSection.storytelling]: {
    image: storytelling,
    width: "90vw",
    height: "auto",
    title: "Data Storytelling"
  },
  [IlluSection.refereeTechnologies]: {
    image: refereeTechnologies,
    height: "70vh",
    width: "auto",
    title: "Referee Technologies"
  },
  [IlluSection.innovation]: {
    image: innovation,
    width: "auto",
    height: "70vh",
    title: "Innovation"
  }
};



// WEBPACK FOOTER //
// ./src/IlluSections.ts